<template>
    <div class="col-md-12">
        <pim-header
            header="Exports"
        ></pim-header>
        <div>
            <transition name="vue-table-loader">
                <div class="vue-table-loader" v-if="loading">
                    <span class="fa fa-cog fa-spin fa-3x"></span>
                </div>
            </transition>
            <div class="row">
                <div class="col-md-4">
                    <base-filter-bar placeholder="Search Exports"></base-filter-bar>
                </div>
                <div class="col-md-8">
                    <base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
                </div>
            </div>
            <div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
                <vuetable
                    ref="vuetable"
                    :api-url="gridUrl"
                    :fields="fields"
                    :css="css.table"
                    :per-page="perPage"
                    :sort-order="sortOrder"
                    :append-params="moreParams"
                    noDataTemplate="No Exports Found"
                    pagination-path=""
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                >
                    <template slot="actions" slot-scope="props">
                        <a v-if="props.rowData.status === 'done'" :href="downloadCSVUrl(props.rowData.id)">
                            <button class="btn btn-success">Download</button>
                        </a>
                        <button v-else class="btn btn-secondary" disabled>Download</button>
                    </template>
                </vuetable>
                <div class="row">
                    <div class="col-md-6">
                        <base-pagination-info
                            :css="css.table"
                            ref="paginationInfo"
                        >
                        </base-pagination-info>
                    </div>
                    <div class="col-md-6">
                        <base-pagination ref="pagination"
                             @vuetable-pagination:change-page="onChangePage"
                        ></base-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    import PimHeader from '../generic/pim-header';
    import BaseFilterBar from '../tables/base-filter-bar.vue';
    import BasePagination from '../tables/base-pagination.vue';
    import BasePaginationInfo from '../tables/base-pagination-info.vue';
    import BaseSelectVisible from '../tables/base-select-visible.vue';

    export default {
        name: 'exports-index',
        components: {
            'base-filter-bar': BaseFilterBar,
            'base-pagination': BasePagination,
            'base-pagination-info': BasePaginationInfo,
            'base-select-visible': BaseSelectVisible,
            'pim-header': PimHeader,
        },
        data() {
            return {
                fields: [
                    {
                        name: 'created_at',
                        title: 'Created',
                        sortField: 'created_at',
                        callback: this.formatDate,
                    },
                    {
                        name: 'profile.name',
                        title: 'Profile Name',
                    },
                    {
                        name: 'status',
                        title: 'Status',
                        callback: this.upperCaseFirstLetter,
                        sortField: 'status',
                    },
                    {
                        name: '__slot:actions',
                        titleClass: 'actions-single-column',
                    },
                ],
                perPage: 10,
                sortOrder: [
                    {
                        field: 'created_at',
                        direction: 'desc',
                    }
                ],
                moreParams: {},
                loading: true,
                amountsShown: [
                    { text: '10', value: 10 },
                    { text: '25', value: 25 },
                    { text: '50', value: 50 },
                    { text: '100', value: 100 }
                ],
                css: {
                    table: {
                        tableClass: 'table table-striped table-bordered table-middle',
                        ascendingIcon: 'sort-icon-asc',
                        descendingIcon: 'sort-icon-desc',
                        infoClass: '',
                    },
                },
            }
        },
        computed: {
            gridUrl() {
                return route('exports.grid');
            }
        },
        methods: {
            formatDate (value) {
                if (value === null) {
                    return 'Never';
                }
                return moment(value).format("MMM Do YY [at] LT");
            },
            downloadCSVUrl(id) {
                return route('exports.download', id);
            },
            onPaginationData (paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },
            onChangePage (page) {
                this.$refs.vuetable.changePage(page)
            },
            doVisibleSet (perPageValue) {
                this.perPage = perPageValue;
                this.$nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterSet (filterText) {
                this.moreParams = {
                    'filter': filterText
                }
                this.$nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterReset () {
                this.moreParams = {}
                this.$nextTick( () => this.$refs.vuetable.refresh())
            },
            onLoaded: function () {
                this.loading = false;
            },
            upperCaseFirstLetter(value) {
                return value[0].toUpperCase() + value.slice(1);
            }
        },
        mounted() {
            this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
            this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
            this.$events.$on('filter-reset', e => this.onFilterReset())
        },
        watch: {
            perPage() {
                this.$nextTick(function() {
                    this.$refs.vuetable.refresh()
                })
            },
        },
    }
</script>

<style scoped>

</style>
